(() => {
  document.addEventListener('submit', (e) => {
    const el = e.target;
    let target;
    let value;

    switch (true) {
    default:
      break;

    case el.matches('.tc-add-to-cart'):
      target = el.querySelector('button[type="submit"]');
      if (window.location.href.indexOf('favorites') > -1 && target) {
        value = target.textContent.trim().replace(/[\d,.]+/, 'x,xx');

        window._paq = window._paq || [];
        window._paq.push([
          'trackEvent',
          'UI',
          'My Favorites',
          value
        ]);
      }
      break;

    case el.matches('.scene form'):
      target = el.querySelector('button[type="submit"]');

      if (target) {
        value = target.textContent.trim().replace(/[\d,.]+/, 'x,xx');

        window._paq_disabled = window._paq_disabled || [];
        window._paq_disabled.push([
          'trackEvent',
          'UI',
          'Scene Box',
          value
        ]);
      }
      break;
    }
  });
  
  document.addEventListener('click', (e) => {
    const el = e.target;
    let target;
    let value;
    let prefetch;

    switch (true) {
    default:
      break;

    case !!el.closest('.swinger-money-back-box'):
      window._paq = window._paq || [];
      window._paq.push([
        'trackEvent',
        'UI',
        'Money Back Box'
      ]);
      break;

    case !!el.closest('.scene a, .scene [data-lb-index]'):
      target = el.closest('.scene a, .scene [data-lb-index]');

      switch (true) {
      default:
        value = target.textContent.trim().replace(/[\d,.]+/, 'x,xx');
        break;

      case target.matches('a:not(.tc-add-to)'):
        value = target.textContent.trim().replace(/[\d,.]+/, 'x,xx');
        window.setTimeout(() => {
          window.location = target.href;
        }, 300);
        prefetch = document.createElement('link');
        prefetch.rel = 'prefetch';
        prefetch.href = target.href;
        document.head.appendChild(prefetch);
        e.preventDefault();
        break;

      case target.matches('.tc-add-to') && !!target.querySelector('.is-default-text'):
        value = target.querySelector('.is-default-text').textContent.trim().replace(/[\d,.]+/, 'x,xx');
        break;

      case target.matches('[data-lb-index]'):
        value = `Image No. ${parseInt(target.getAttribute('data-lb-index'), 10) + 1}`;
        break;
      }

      window._paq_disabled = window._paq_disabled || [];
      window._paq_disabled.push([
        'trackEvent',
        'UI',
        'Scene Box',
        value
      ]);
      break;
    }
  }, true);
})();
